import SpriteSymbol from "../../../../dev-d21-front/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../dev-d21-front/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "workflow-online",
  "use": "workflow-online-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"workflow-online\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M10 16.667h.008M1.667 7.35a12.5 12.5 0 0 1 16.666 0M4.167 10.716a8.333 8.333 0 0 1 11.666 0m-8.75 2.975a4.167 4.167 0 0 1 5.834 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol